// Floating slash-command palette anchored above the composer bubble.
import { Box } from "@mui/material";
import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import { isDarkMode } from "../../utils/constants";

const SlashCommandMenu = ({
  commands,
  activeIndex,
  bottomOffset,
  onSelect,
  onHighlight,
}) => (
  <Box
    data-chat-slash-menu
    sx={{
      position: "absolute",
      left: 0,
      right: 0,
      bottom: `${bottomOffset}px`,
      zIndex: 7,
      borderRadius: "16px",
      py: 0.5,
      backgroundColor: isDarkMode
        ? "rgba(37,37,37,0.96)"
        : "rgba(236,238,243,0.96)",
      border: isDarkMode
        ? "1px solid rgba(255,255,255,0.08)"
        : "1px solid rgba(0,0,0,0.06)",
      boxShadow: isDarkMode
        ? "0 8px 24px rgba(0,0,0,0.28)"
        : "0 8px 20px rgba(15,23,42,0.10)",
    }}
  >
    {commands.map((command, index) => {
      const isActive = index === activeIndex;
      return (
        <Box
          key={command.key}
          onClick={() => onSelect(command)}
          onMouseEnter={() => onHighlight(index)}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1.5,
            mx: 0.75,
            px: 1.25,
            py: 0.9,
            borderRadius: "10px",
            cursor: "pointer",
            backgroundColor: isActive
              ? isDarkMode
                ? "rgba(255,255,255,0.08)"
                : "rgba(0,0,0,0.06)"
              : "transparent",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.6, minWidth: 0 }}>
            <Box
              sx={{
                fontSize: "0.86rem",
                fontWeight: 600,
                color: isDarkMode ? "#f5f5f5" : "#121212",
                whiteSpace: "nowrap",
              }}
            >
              /{command.command}
            </Box>
            {command.isMax && (
              <BoltRoundedIcon sx={{ fontSize: 15, color: "#F59E0B" }} />
            )}
          </Box>
          <Box
            sx={{
              fontSize: "0.76rem",
              color: isDarkMode
                ? "rgba(255,255,255,0.55)"
                : "rgba(18,18,18,0.55)",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {command.description}
          </Box>
        </Box>
      );
    })}
  </Box>
);

export default SlashCommandMenu;
